
<div class="row mt-3">
  <div class="col-md-3">

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Filter</mat-label>
      <mat-select placeholder="category" (selectionChange)="onSelectCat($event)" [(ngModel)]="selectedCategory" name="category">
        <mat-option *ngFor="let category of categories" [value]="category.value">
          {{category.viewValue}}
        </mat-option>
      </mat-select>
      
    </mat-form-field>




  </div>
  <div class="col-md-6">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Suchbegriff</mat-label>
      <ng-container *ngIf="selectedCategory !== 'pre_location' && selectedCategory !== 'pre_person'; else autocomplete">
        <input matInput type="text" (keyup.enter)="submitSearch()" [(ngModel)]="queryText" (keyup)="onSearchChange(queryText)" placeholder="Suche ...">
      </ng-container>
      
      <ng-template #autocomplete>
        <ng-container [ngTemplateOutlet]="selectedCategory === 'pre_location' ? cityAutocomplete : personAutocomplete"></ng-container>
      </ng-template>

      
      <ng-template #cityAutocomplete>
        <input type="text" placeholder="Stadt eingeben" (keyup.enter)="submitSearch()" aria-label="Number" matInput [formControl]="queryTextCtrl" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let city of filteredCities | async" [value]="city.key">
            {{city.key}}
          </mat-option>
        </mat-autocomplete>
      </ng-template>
      <ng-template #personAutocomplete>
        <input type="text" placeholder="Person eingeben" aria-label="Number" (keyup.enter)="submitSearch()" matInput [formControl]="queryTextCtrl" [matAutocomplete]="personAuto">
        <mat-autocomplete #personAuto="matAutocomplete">
          <mat-option *ngFor="let person of filteredPersons | async" [value]="person.key">
            {{person.key}}
          </mat-option>
        </mat-autocomplete>
      </ng-template>

 
    </mat-form-field>
  </div>

  <div class="col-md-3">
      <mat-form-field appearance="outline" class="w-100">
          <mat-label>Suchoperatoren</mat-label>
          <mat-select placeholder="Operator" [(ngModel)]="selectedOperator" (selectionChange)="onSelectOpt($event)" name="operator">
              <mat-option *ngFor="let operator of operators" [value]="operator.value" >
                {{operator.viewValue}}
              </mat-option>
          </mat-select>
         
        </mat-form-field>
  </div>


</div>




<div class="row">
    <div class="col-md-3">
      <button mat-raised-button class="w-100 mb-2 blue" color="primary" (click)="submitSearch()">Suche</button>
    </div>

    <div class="col-md-6">

    </div>
    <div class="col-md-3 d-flex justify-content-end">
      
     <mat-form-field appearance="outline" class="w-100">
      <mat-label>Sortierung</mat-label>
        <mat-select placeholder="Sortierung" [(ngModel)]="selectedSorting" (selectionChange)="onSelectSort($event)" name="Sortierung">
          <mat-option (click)="submitSearch()" *ngFor="let sorting of sortings" [value]="sorting.value">
            {{sorting.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field> 
    </div>


 
    
  </div>



